import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Box, Typography } from '@mui/material';
import MainLogo from 'assets/main-logo-white.png';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';

const WHATSAPP_URL = 'https://wa.me/972544780198';

export const AuthenticationLayout = ({ page = 'login' }) => {
  const { t } = useTranslation();
  const headerText =
    page === 'login' 
      ? t('LOGIN_HEADER')
      : page === 'adminLogin'
        ? t('ADMIN_LOGIN_HEADER')
        : page === 'reset' ? t('FORGOT_RESET_HEADER') : t('FORGOT_HEADER') ;
  const headerClass =
    page === 'login' || page === 'reset' ? 'login-box-container' : 'login-box-container-smaller';

  return (
    <>
      <Box className='login-container'>
        <Box className='login-background' />
        <Box sx={{paddingBottom:"30px"}} >
          <LanguageSwitcher />
        </Box>
        <Box className='login-content-container'>
          <Box className={headerClass}>
            <Box className='login-content'>
              <Typography textAlign={"center"} variant='h2'>{headerText}</Typography>
              <Outlet />
            </Box>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", marginTop: "1rem" }}>
            <img src={MainLogo} className='h-12' alt='LOGO' style={{margin:"10px"}} />
            {page === 'adminLogin' ? (
              <></>
            ) : (
              <Typography
                variant='body2'
                component={'h2'}
                color='white'
                sx={{ zIndex: '3', fontSize: "18px", fontWeight: "600" }}
              >
                {t('LOGIN_QUOTE')} |{' '}
                <Link to='/signup'>{t('LOGIN_REGISTER_BTN_TEXT')}</Link>
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
      {page === 'login' && (
        <a
          className="login-whatsapp"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp +972 54-478-0198"
        >
          <WhatsAppIcon sx={{ fontSize: 36 }} />
        </a>
      )}
    </>
  );
};